import { Reducer } from 'redux'
import { IAction, IModalsState } from 'apps/fleet-planner/types/base'
import {
  UPDATE_LOAD_ACTION_TYPES,
  DELETE_LOAD_ACTION_TYPES,
} from 'apps/fleet-planner/utils/actions/loadDetails'
import { CREATE_LOAD_ACTION_TYPES } from 'apps/fleet-planner/utils/actions/loads'
import { MODAL_ACTION_TYPES } from '../actions/modals'

const { CREATE_LOAD_FAILURE, CREATE_LOAD_REQUEST, CREATE_LOAD_SUCCESS } = CREATE_LOAD_ACTION_TYPES

const { UPDATE_LOAD_FAILURE, UPDATE_LOAD_REQUEST, UPDATE_LOAD_SUCCESS } = UPDATE_LOAD_ACTION_TYPES

const { DELETE_LOAD_FAILURE, DELETE_LOAD_REQUEST, DELETE_LOAD_SUCCESS } = DELETE_LOAD_ACTION_TYPES

const {
  CLOSE_DRIVER_OPT_IN_MODAL,
  DISMISS_SHARE_LOAD_TOAST,
  OPEN_DRIVER_OPT_IN_MODAL,
  SHOW_SHARE_LOAD_TOAST,
} = MODAL_ACTION_TYPES

type ModalsAction = IAction

const defaultState: IModalsState = { drivers: [] }

const modalsReducer: Reducer<IModalsState, ModalsAction> = (state = defaultState, action) => {
  switch (action.type) {
    case DELETE_LOAD_REQUEST:
    case UPDATE_LOAD_REQUEST:
    case CREATE_LOAD_REQUEST: {
      return {
        ...state,
        actionInProgress: true,
        error: undefined,
      }
    }

    case DELETE_LOAD_FAILURE:
    case UPDATE_LOAD_FAILURE:
    case CREATE_LOAD_FAILURE: {
      return {
        ...state,
        actionInProgress: false,
        error: (action as IAction).error,
      }
    }

    case DELETE_LOAD_SUCCESS:
    case UPDATE_LOAD_SUCCESS:
    case CREATE_LOAD_SUCCESS: {
      return {
        ...state,
        actionInProgress: false,
      }
    }
    case OPEN_DRIVER_OPT_IN_MODAL: {
      const { payload } = action || {}
      const { drivers } = payload
      return {
        ...state,
        isDriverOptInModalOpen: true,
        drivers,
      }
    }
    case CLOSE_DRIVER_OPT_IN_MODAL: {
      return {
        ...state,
        isDriverOptInModalOpen: false,
        drivers: [],
      }
    }
    case SHOW_SHARE_LOAD_TOAST: {
      const { payload } = action || {}
      const { message, shipmentId } = payload
      return {
        ...state,
        shareLoads: {
          shipmentId,
          message,
        },
      }
    }
    case DISMISS_SHARE_LOAD_TOAST: {
      return {
        ...state,
        shareLoads: {},
      }
    }

    default:
      return state
  }
}

export default modalsReducer
